import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('EQUIPMENTS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class EquipmentsService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'equipments' como el nombre del recurso a la clase base
    super('equipments');
    log.debug('Servicio de Equipos inicializado');
  }

}
